<!-- Start Page Header -->
<div class="page-header">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <h2 class="entry-title">{{'career' | translate}}</h2>
                <div class="breadcrumb">
                    <span>{{'here' | translate}}: </span>
                    <a routerLink="/Home"> {{'home' | translate}}</a>
                    <span class="crumbs-spacer"><i class="fa fa-angle-double-right"></i></span>
                    <span class="current">{{'career' | translate}}</span>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- End Page Header -->

<!-- Start Content Section -->
<section id="content">
    <div class="container">

        <div class="panel-group" id="accordion">
            <!-- Start Accordion 1 -->
            <div class="panel panel-default">
                <!-- Toggle Heading -->
                <div class="panel-heading">
                    <h4 class="panel-title">
                        <a data-toggle="collapse" data-parent="#accordion" href="#collapse-1" class=""
                            aria-expanded="true">
                            {{'HealthInsurance' | translate}}
                        </a>
                    </h4>
                </div>
                <!-- Toggle Content -->
                <div id="collapse-1" class="panel-collapse collapse in" aria-expanded="true">
                    <div class="panel-body">
                        <p>{{'HealthInsuranceDes' | translate}}</p>
                    </div>
                </div>
            </div>
            <!-- End Accordion 1 -->
            <!-- Start Accordion 2 -->
            <div class="panel panel-default">
                <!-- Toggle Heading -->
                <div class="panel-heading">
                    <h4 class="panel-title">
                        <a data-toggle="collapse" data-parent="#accordion" href="#collapse-2" class="collapsed"
                            aria-expanded="false">
                            {{'Company-Paid' | translate}}
                        </a>
                    </h4>
                </div>
                <!-- Toggle Content -->
                <div id="collapse-2" class="panel-collapse collapse " aria-expanded="false">
                    <div class="panel-body">
                        <p>{{'Company-PaidDes' | translate}}</p>
                    </div>
                </div>
            </div>
            <!-- End Accordion 2 -->
            <!-- Start Accordion 3 -->
            <div class="panel panel-default">
                <!-- Toggle Heading -->
                <div class="panel-heading">
                    <h4 class="panel-title">
                        <a data-toggle="collapse" data-parent="#accordion" href="#collapse-3" class="collapsed"
                            aria-expanded="false">
                            {{'SpiritualityBenefits' | translate}}
                        </a>
                    </h4>
                </div>
                <!-- Toggle Content -->
                <div id="collapse-3" class="panel-collapse collapse" aria-expanded="false">
                    <div class="panel-body">
                        <p>{{'SpiritualityBenefitsDes' | translate}}</p>
                    </div>
                </div>
            </div>
            <!-- End Accordion 3 -->
            <!-- Start Accordion 4 -->
            <!--    <div class="panel panel-default">-->
            <!-- Toggle Heading -->
            <!--<div class="panel-heading">
                            <h4 class="panel-title">
                                <a data-toggle="collapse" data-parent="#accordion" href="#collapse-4" class="collapsed" aria-expanded="false">
                                    Sed adipiscing ornare risus.
                                </a>
                            </h4>
                        </div>-->
            <!-- Toggle Content -->
            <!--<div id="collapse-4" class="panel-collapse collapse" aria-expanded="false">
                            <div class="panel-body">
                                <p>Donec ornare mattis suscipit. Praesent fermentum accumsan vulputate. Sed velit nulla, sagittis non erat id, dictum vestibulum ligula. Maecenas sed enim sem. Etiam scelerisque gravida purus nec interdum. Phasellus venenatis ligula in faucibus consequat. Aliquam dictum nulla eu varius porta. Maecenas congue.</p>
                            </div>
                        </div>-->
            <!--</div>-->
            <!-- End Accordion 4 -->
        </div>

        <div class="hr5" style="margin-top:50px; margin-bottom:55px;"></div>
        <div class="positions">
            <div class="tabs-section">
                <!-- Start Big title -->
                <h1 class="big-title">
                    {{'OpenPositions' | translate}}
                </h1>
                <!-- Nav Tabs -->
                <ul class="nav nav-tabs">
                    <li class="active tabs-1 " title="Sort By Job Title"><a href="#tab-1" data-toggle="tab"> {{'JobPosting' | translate}} &nbsp;
                            <img src="../../../../assets/images/up-down-128.png" /></a></li>
                    <li class="tabs-2" title="Sort By Location"><a href="#tab-2" data-toggle="tab">{{'Location' | translate}}&nbsp;<img
                                src="../../../../assets/images/up-down-128.png" /></a></li>

                    <li class="tabs-4" title="Sort By Date"><a href="#tab-4" data-toggle="tab">{{'Date' | translate}}&nbsp;<img
                                src="../../../../assets/images/up-down-128.png" /></a></li>
                </ul>
                <!-- Tab panels -->
                <div class="tab-content" style="text-align: center">
                    <div id="imageLoader">
                        <img src="../../../../assets/images/ajax-loader.gif" /><br />
                        Loading.......
                    </div>
                    <!-- Tab Content 1 -->
                    <div class="tab-pane fade in active " id="tab-1">
                        <table class="table" id="jobSortByTitle">
                            <tbody>

                            </tbody>
                        </table>
                    </div>
                    <!-- Tab Content 2 -->
                    <div class="tab-pane fade" id="tab-2">
                        <table class="table" id="jobSortByLocation">
                            <tbody></tbody>
                        </table>
                    </div>

                    <!-- Tab Content 4 -->
                    <div class="tab-pane fade" id="tab-4">
                        <table class="table" id="jobSortByDate">
                            <tbody></tbody>
                        </table>

                    </div>
                </div>
                <!-- End Tab Panels -->
            </div>
        </div>
    </div>

</section>